import Head from 'next/head';
import React from 'react';
import { SITE_NAME, SocialMeta as SocialMetaType, TWITTER_HANDLE } from '../../lib/social-meta';

// `key`s let a page's tags replace these instead of duplicating them.
const SocialMeta = ({ title, description, url, image, imageAlt }: SocialMetaType) => (
  <Head>
    <meta key="description" name="description" content={description} />
    <meta key="og:type" property="og:type" content="website" />
    <meta key="og:site_name" property="og:site_name" content={SITE_NAME} />
    <meta key="og:title" property="og:title" content={title} />
    <meta key="og:description" property="og:description" content={description} />
    <meta key="og:url" property="og:url" content={url} />
    <meta key="og:image" property="og:image" content={image} />
    <meta key="og:image:type" property="og:image:type" content="image/png" />
    <meta key="og:image:width" property="og:image:width" content="1200" />
    <meta key="og:image:height" property="og:image:height" content="630" />
    <meta key="og:image:alt" property="og:image:alt" content={imageAlt} />
    <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
    <meta key="twitter:site" name="twitter:site" content={TWITTER_HANDLE} />
    <meta key="twitter:title" name="twitter:title" content={title} />
    <meta key="twitter:description" name="twitter:description" content={description} />
    <meta key="twitter:image" name="twitter:image" content={image} />
    <meta key="twitter:image:alt" name="twitter:image:alt" content={imageAlt} />
  </Head>
);

export default SocialMeta;
